export const IS_LOCAL_DEV = process.env.NODE_ENV === 'development';
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || '';
export const IS_EDITOR_MODE = /\/form\/\w+\/\d+\/edit$/i.test(window.location.pathname);
export const APP_RUNNING_ENV = process.env.REACT_APP_RUNNING_ENV || 'prod';
export const IS_LIVE_PROD = APP_RUNNING_ENV === 'prod' && !IS_LOCAL_DEV;

export const FROALA_V2_KEY =
    process.env.REACT_APP_FROALA_V2_KEY_GENERAL || 'fB4F3E3F2E2D2C5zA3B2A1G3F4F1I1A10B1D6mc1VYJZa1c2a1THYBUZY==';

export const FROALA_KEY =
    process.env.REACT_APP_FROALA_V4_KEY_GENERAL || 'fIE3A-9C2I2I2C6B3C4C2ud1BI1IMNBUMRWAi1AYMSTRBUZYB-16D4E3D2D1C3H2D1B10C2B1==';
export const EDITOR_WINDOW_ORIGIN = process.env.REACT_APP_FEVER_HOST
    ? `https://${process.env.REACT_APP_FEVER_HOST}`
    : window.location.origin;
export const NEW_FEVER_HOST =
    process.env.REACT_APP_FEVER_HOST || filterFeverWWWDomain(window.location.host);
export const INTERCOM_SECRET_KEY =
    process.env.REACT_APP_INTERCOM_SECRET_KEY || 'xdsqVb3gLQtypbClG8EZFFSh4Mx_PRTcHLTQT073';
export const SENTRY_REACT_DSN =
    process.env.REACT_APP_SENTRY_REACT_DSN || 'https://cc3443b50349084a1887d5da1a40e809@o512271.ingest.us.sentry.io/4506478155268096';

export const { FEVER_API_ENDPOINT, IMG_PROXY_PATH } = (runningEnv => {
    switch (runningEnv) {
        case 'prod':
            return {
                FEVER_API_ENDPOINT: 'https://api.feversocial.com',
                IMG_PROXY_PATH: 'https://image.fevercdn.com'
            };
        case 'dev':
        default:
            return {
                FEVER_API_ENDPOINT: 'https://api.dev.feversocial.com',
                IMG_PROXY_PATH: 'https://image.fevercdn.com/dev'
            };
    }
})(APP_RUNNING_ENV);

function filterFeverWWWDomain(host) {
    return host === 'www.feversocial.com' ? 'feversocial.com' : host;
}
